// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28LkN","footer":"styles_footer__2UjYq","passCodeTooltip":"styles_passCodeTooltip__hv92u"};